import React from 'react';
import { Link } from 'react-router-dom';
import './breadcrumb.scss';

export function Breadcrumb(props) {
  return (
    <div id="breadcrumb">
      <div className="container">
        <ul>
          {props.links.map((link, i) =>
            i === props.links.length - 1 ? (
              <li key={link.text}>{link.text}</li>
            ) : (
              <li key={link.text}>
                <Link to={link.to}>{link.text}</Link>
              </li>
            )
          )}
        </ul>
      </div>
    </div>
  );
}

export default Breadcrumb;
